require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./feature-burning-man-tips.json") })
        }
      }, "path---feature-burning-man-tips");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---feature-burning-man-tips!./.cache/json/feature-burning-man-tips.json
// module id = 637
// module chunks = 231608221292675